import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import FlagIcon from './FlagIcon';
import { salaryText, salaryKesText, commissionText } from '../lib/salary';
import './JobCard.css';

// The whole card is a link to the job's full PUBLIC detail page (/jobs/:slug), viewable by anyone —
// signed in or not. "Apply" is deliberately NOT a direct action here (no quick-apply, no wizard):
// the application always starts from INSIDE the detail view (its "Apply for this job" CTA ->
// /apply/:slug), so a candidate sees the full role before committing. The "Apply ->" affordance
// below is just the visual cue that the card opens that detail page.
const JobCard = ({ job }) => {
  const kes = salaryKesText(job.salary);
  // Null unless the demand has a candidate charge AND the admin has the commission field visible.
  const commission = commissionText(job.commission);
  return (
    <Link to={`/jobs/${job.slug}`} className="job-card">
      <h3 className="job-card-title">{job.title}</h3>
      <div className="job-card-meta">
        {job.country && <span><FlagIcon country={job.country} /> {job.country}</span>}
      </div>
      {job.subtitle && <p className="job-card-sub">{job.subtitle}</p>}
      <div className="job-card-bottom">
        <div className="job-card-sal-col">
          <span className="job-card-salary">{salaryText(job.salary)}</span>
          {kes && <span className="job-card-kes">{kes}</span>}
          {/* Commission sits under the salary so a candidate sees earnings and cost together, rather
              than discovering the cost only after they have applied. */}
          {commission && <span className="job-card-commission">Commission {commission}</span>}
        </div>
        <span className="job-card-apply">Apply <ArrowRight size={14} aria-hidden="true" /></span>
      </div>
    </Link>
  );
};
export default JobCard;
